/**
 *  Used to create a type error when we expect an if-else or
 * switch statement to be exhaustive. Shouldn't be callable
 * in checked code but will throw an error if called.
 *  */
export function assertCasesExhausted(value) {
    throw new Error("Fell out of a checked exhaustive switch with value: " + JSON.stringify(value));
}
/**
 *  Used to create a type error when we expect an if-else or
 * switch statement to be exhaustive. Shouldn't be callable
 * in checked code. This version doesn't throw any error and
 * relies on the caller to surface the error to the user.
 *  */
export function assertCasesExhaustedSilently(value) {
    console.error("Fell out of a checked exhaustive switch with value: " + JSON.stringify(value));
}
//# sourceMappingURL=assert-cases-exhausted.js.map